import useUserDetailQuery from "features/user/hooks/queries/useUserDetailQuery";
import useDocumentDetailQuery from "../queries/detail/useDocumentDetailQuery";
import { useEffect, useState } from "react";
import { DocumentAccessType } from "models/document/DocumentAccessType";
import { useNavigate } from "react-router-dom";
import checkDocumentAccessType from "features/document/utils/checkDocumentAccessType";

interface UseDocumentDetailRedirectProps {
  documentUuid: string;
}

const useDocumentDetailRedirect = ({
  documentUuid,
}: UseDocumentDetailRedirectProps) => {
  const { data: currentUser } = useUserDetailQuery();
  const [accessType, setAccessType] = useState<DocumentAccessType>("BLOCK");

  const { data: document, isSuccess } = useDocumentDetailQuery(documentUuid);

  const navigate = useNavigate();

  useEffect(() => {
    if (!(isSuccess && currentUser && document)) return;

    const accessType = checkDocumentAccessType({ user: currentUser, document });
    setAccessType(accessType);

    if (accessType === "BLOCK") navigate(-1);
  }, [currentUser, isSuccess, document]);

  return { accessType };
};

export default useDocumentDetailRedirect;
